import React from "react";
import {
  Container,
  Typography,
  Box,
  CardMedia,
  Chip,
  Stack,
  Grid,
  Dialog,
  IconButton,
  Button,
  Divider,
} from "@mui/material";

import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";

import { useNavigate, useParams } from "react-router-dom";

import eventos from "./Eventos.js";

export const EventosDetalle = () => {

  // ======================================================
  // ID DEL EVENTO
  // ======================================================

  const { id } = useParams();

  const navigate = useNavigate();

  // ======================================================
  // BUSCAR EVENTO
  // ======================================================

  const evento = eventos.find(
    (evento) => evento.id === Number(id)
  );

  // ======================================================
  // ESTADO DE LA GALERÍA
  // ======================================================

  const [open, setOpen] = React.useState(false);

  const [fotoSeleccionada, setFotoSeleccionada] =
    React.useState(0);

  // ======================================================
  // SI NO EXISTE EL EVENTO
  // ======================================================

  if (!evento) {
    return (
      <Container maxWidth="lg">

        <Box
          sx={{
            py: 10,
            textAlign: "center",
          }}
        >

          <Typography
            variant="h4"
            sx={{
              color: "#0C213D",
              fontWeight: 700,
              mb: 2,
            }}
          >
            Evento no encontrado
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate("/eventos")}
            sx={{
              backgroundColor: "#0C213D",
              textTransform: "none",

              "&:hover": {
                backgroundColor: "#18385f",
              },
            }}
          >
            Regresar a eventos
          </Button>

        </Box>

      </Container>
    );
  }

  // ======================================================
  // ABRIR FOTOGRAFÍA
  // ======================================================

  const handleOpenFoto = (index) => {
    setFotoSeleccionada(index);
    setOpen(true);
  };

  // ======================================================
  // CERRAR GALERÍA
  // ======================================================

  const handleClose = () => {
    setOpen(false);
  };

  // ======================================================
  // FOTO ANTERIOR
  // ======================================================

  const handleAnterior = () => {

    setFotoSeleccionada((actual) => {

      if (actual === 0) {
        return evento.fotografias.length - 1;
      }

      return actual - 1;
    });

  };

  // ======================================================
  // FOTO SIGUIENTE
  // ======================================================

  const handleSiguiente = () => {

    setFotoSeleccionada((actual) => {

      if (
        actual ===
        evento.fotografias.length - 1
      ) {
        return 0;
      }

      return actual + 1;
    });

  };

  return (
    <Container maxWidth="lg">

      {/* ==================================================
          REGRESAR
      ================================================== */}

      <Box
        sx={{
          mt: 4,
          mb: 3,
        }}
      >

        <Button
          startIcon={<ArrowBackIosNewIcon />}
          onClick={() => navigate("/eventosImportantes")}
          sx={{
            color: "#0C213D",
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          Regresar a eventos
        </Button>

      </Box>

      {/* ==================================================
          INFORMACIÓN DEL EVENTO
      ================================================== */}

      <Box
        sx={{
          mb: 5,
        }}
      >

        {/* Imagen principal */}

        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: {
              xs: 280,
              sm: 400,
              md: 500,
            },
            overflow: "hidden",
            borderRadius: "12px",
            mb: 4,
          }}
        >

          <CardMedia
            component="img"
            src={evento.imagenPrincipal}
            alt={evento.nombre}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />

          <Chip
            label={evento.categoria}
            sx={{
              position: "absolute",
              left: 20,
              bottom: 20,

              backgroundColor: "#0C213D",
              color: "#fff",

              fontWeight: 600,
              fontSize: "0.9rem",
            }}
          />

        </Box>

        {/* ==================================================
            TÍTULO
        ================================================== */}

        <Typography
          variant="h3"
          sx={{
            color: "#0C213D",
            fontWeight: 800,
            mb: 2,

            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
        >
          {evento.nombre}
        </Typography>

        {/* ==================================================
            FECHA Y LUGAR
        ================================================== */}

        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={{
            xs: 1,
            sm: 3,
          }}
          sx={{
            mb: 3,
          }}
        >

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
          >

            <CalendarMonthOutlinedIcon
              sx={{
                color: "#0C213D",
              }}
            />

            <Typography
              sx={{
                color: "#666",
              }}
            >
              {evento.fecha}
            </Typography>

          </Stack>

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
          >

            <LocationOnOutlinedIcon
              sx={{
                color: "#0C213D",
              }}
            />

            <Typography
              sx={{
                color: "#666",
              }}
            >
              {evento.lugar}
            </Typography>

          </Stack>

        </Stack>

        <Divider
          sx={{
            mb: 3,
          }}
        />

        {/* ==================================================
            DESCRIPCIÓN
        ================================================== */}

        <Typography
          variant="h5"
          sx={{
            color: "#0C213D",
            fontWeight: 700,
            mb: 1.5,
          }}
        >
          Descripción
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#666",
            lineHeight: 1.8,
            maxWidth: "900px",
            mb: 5,
          }}
        >
          {evento.descripcion}
        </Typography>

      </Box>

      {/* ==================================================
          GALERÍA
      ================================================== */}

      <Box
        sx={{
          mb: 7,
        }}
      >

        <Typography
          variant="h4"
          sx={{
            color: "#0C213D",
            fontWeight: 800,
            mb: 1,
          }}
        >
          Fotografías
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "#777",
            mb: 3,
          }}
        >
          {evento.fotografias.length} fotografías del evento
        </Typography>

        <Grid
          container
          spacing={2}
        >

          {evento.fotografias.map(
            (fotografia, index) => (

              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={index}
              >

                <Box
                  onClick={() =>
                    handleOpenFoto(index)
                  }
                  sx={{
                    height: {
                      xs: 250,
                      sm: 220,
                      md: 240,
                    },

                    borderRadius: "10px",
                    overflow: "hidden",

                    cursor: "pointer",

                    position: "relative",

                    "&:hover img": {
                      transform: "scale(1.06)",
                    },
                  }}
                >

                  <Box
                    component="img"
                    src={fotografia}
                    alt={`${evento.nombre} - fotografía ${
                      index + 1
                    }`}
                    loading="lazy"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",

                      transition:
                        "transform 0.4s ease",
                    }}
                  />

                  {/* Número de fotografía */}

                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 10,
                      right: 10,

                      backgroundColor:
                        "rgba(12,33,61,0.85)",

                      color: "#fff",

                      px: 1.2,
                      py: 0.5,

                      borderRadius: "5px",

                      fontSize: "0.8rem",
                    }}
                  >
                    {index + 1} /{" "}
                    {evento.fotografias.length}
                  </Box>

                </Box>

              </Grid>

            )
          )}

        </Grid>

      </Box>

      {/* ==================================================
          DIALOG / GALERÍA
      ================================================== */}

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#000",
            overflow: "hidden",
          },
        }}
      >

        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "85vh",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >

          {/* ==================================================
              CERRAR
          ================================================== */}

          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              zIndex: 10,

              color: "#fff",

              backgroundColor:
                "rgba(12,33,61,0.8)",

              "&:hover": {
                backgroundColor:
                  "rgba(12,33,61,1)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* ==================================================
              FOTO
          ================================================== */}

          <Box
            component="img"
            src={
              evento.fotografias[
                fotoSeleccionada
              ]
            }
            alt={`${evento.nombre} - fotografía ${
              fotoSeleccionada + 1
            }`}
            sx={{
              maxWidth: "90%",
              maxHeight: "80%",
              objectFit: "contain",
            }}
          />

          {/* ==================================================
              ANTERIOR
          ================================================== */}

          <IconButton
            onClick={handleAnterior}
            sx={{
              position: "absolute",
              left: {
                xs: 5,
                sm: 20,
              },

              color: "#fff",

              backgroundColor:
                "rgba(12,33,61,0.8)",

              "&:hover": {
                backgroundColor:
                  "rgba(12,33,61,1)",
              },
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>

          {/* ==================================================
              SIGUIENTE
          ================================================== */}

          <IconButton
            onClick={handleSiguiente}
            sx={{
              position: "absolute",
              right: {
                xs: 5,
                sm: 20,
              },

              color: "#fff",

              backgroundColor:
                "rgba(12,33,61,0.8)",

              "&:hover": {
                backgroundColor:
                  "rgba(12,33,61,1)",
              },
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>

          {/* ==================================================
              CONTADOR
          ================================================== */}

          <Box
            sx={{
              position: "absolute",
              bottom: 15,
              left: "50%",
              transform: "translateX(-50%)",

              backgroundColor:
                "rgba(12,33,61,0.9)",

              color: "#fff",

              px: 2,
              py: 0.8,

              borderRadius: "6px",

              fontWeight: 600,
            }}
          >
            {fotoSeleccionada + 1} /{" "}
            {evento.fotografias.length}
          </Box>

        </Box>

      </Dialog>

    </Container>
  );
};

export default EventosDetalle;